const STORAGE_KEY = 'auth:redirectAfterLogin';
const DEFAULT_REDIRECT = '/';
const BLOCKED_PREFIXES = ['/login', '/auth/', '/404'];

function isSafeInternalPath(path: string): boolean {
  if (typeof path !== 'string' || path.length === 0) return false;
  if (!path.startsWith('/')) return false;
  if (path.startsWith('//')) return false;
  if (path.includes('://')) return false;
  if (BLOCKED_PREFIXES.some((prefix) => path === prefix || path.startsWith(`${prefix}/`) || path.startsWith(`${prefix}?`))) {
    return false;
  }
  return true;
}

export function setRedirectAfterLogin(path: string): void {
  if (!isSafeInternalPath(path)) return;
  try {
    sessionStorage.setItem(STORAGE_KEY, path);
  } catch {
    // sessionStorage indisponível (modo privado, quota): segue sem persistir.
  }
}

export function consumeRedirectAfterLogin(): string {
  let stored: string | null = null;
  try {
    stored = sessionStorage.getItem(STORAGE_KEY);
    if (stored !== null) sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    return DEFAULT_REDIRECT;
  }
  if (stored && isSafeInternalPath(stored)) return stored;
  return DEFAULT_REDIRECT;
}
